import * as STD                            from '@emersya/mpa-std-lib';

import CM                from '@emersya/mpa-components-manager-lib';
import { InputButton }   from '@emersya/mpa-components-lib';

export interface IStandingCarpetImprintTileComponentConfiguration extends InputButton.Configuration {
	SKU : string;
	component : string;
};

export class StandingCarpetImprintTileComponent extends InputButton.Component {
	static override initialize() {
		super.initialize();
	};

	static override getInputEventSubType() {
		const parentClass = (<(typeof CM.Component) []> <any> STD.object.getInheritanceChainFromClass(this))[ 1 ];
		if (!parentClass) {
			throw STD.errors.library('Should inherits from Input Button');
		}
		return parentClass.type;
	};

	constructor(
		descriptor : ConstructorParameters<typeof CM.Component>[0],
		configuration : IStandingCarpetImprintTileComponentConfiguration
	)
	{
		super(descriptor, configuration);
	};
};
export namespace NS {
	export const Component = StandingCarpetImprintTileComponent;
	export type Component = StandingCarpetImprintTileComponent;
	export type Configuration = IStandingCarpetImprintTileComponentConfiguration;
}
import manifestXMLSource from './StandingCarpetImprintTile.xml';
import './StandingCarpetImprintTile.scss';

CM.declare({
	id :       'standing-carpetImprint-tile',
	type :     StandingCarpetImprintTileComponent,
	manifest : manifestXMLSource
});
